// Remove this terrible shit when Angular is gone!
export function TerribleAngularRedirectFix_DO_NOT_USE() {
	window.location.reload();

	return null;
}
